<template>
    <div class="app-inner">
        <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">姓名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <el-input v-model="searchFrom.chineseName" clearable placeholder="请输入" class="inputDiv"></el-input>
            </div>
            <div class="stateDiv">
                <p class="searchText">性别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <el-select v-model="searchFrom.sex" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">民族</p>
                <el-select v-model="searchFrom.nationality" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in nationData" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">联系电话</p>
                <el-input v-model="searchFrom.tel" clearable placeholder="请输入" class="inputDiv"></el-input>
            </div>
        </div>
        <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">出生日期</p>
                <el-date-picker v-model="birthday" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" />
            </div>
            <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
            <el-button class="searchBtn" type="warning" @click="addFormData">添加成员</el-button>
        </div>
        <!--      列表-->
        <div class="table">
            <div class="searchList">
                <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount"
                    @pageChange="handleCurrentChange">
                    <template #action="{ row, index }" class="tableButton">
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
                        </el-button>
                        <!-- <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
            </el-button> -->
                        <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button>
                    </template>
                </TableList>
            </div>
        </div>
        <!--    新增/编辑弹框-->
        <div class="dialogDiv">
            <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
                <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px"
                    :disabled="eventControl === '查看详情'">
                    <el-row>
                        <el-form-item label="姓名" prop="chineseName" class="formItem">
                            <el-input v-model="addForm.chineseName" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="性别" prop="sex" class="formItem">
                            <el-select v-model="addForm.sex" placeholder="请选择" class="inputDiv" clearable
                                style="width:100%">
                                <el-option v-for="item in sexOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="所属公司">
                            <el-select v-model="addForm.companyId" placeholder="请选择所属公司" clearable style="width:100%" filterable>
                                <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName"
                                    :value="item.companyId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="出生年月" prop="birthday" class="formItem">
                            <el-date-picker v-model="addForm.birthday" value-format="yyyy-MM-dd" type="date" 
                                placeholder="选择日期时间" style="width:100%" :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="民族" prop="nationality" class="formItem">
                            <el-select v-model="addForm.nationality" placeholder="请选择" class="inputDiv" clearable filterable
                                style="width:100%">
                                <el-option v-for="item in nationData" :key="item.id" :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="联系电话" prop="tel" class="formItem">
                            <el-input v-model="addForm.tel" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="邮箱" prop="email" class="formItem">
                            <el-input v-model="addForm.email" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="学历" prop="educational" class="formItem">
                            <el-select v-model="addForm.educational" placeholder="请选择" class="inputDiv" clearable
                                style="width:100%">
                                <el-option v-for="item in educationData" :key="item.id" :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="入党日期" prop="joinDate" class="formItem">
                            <el-date-picker v-model="addForm.joinDate" value-format="yyyy-MM-dd" type="date" :picker-options="pickerOptions"
                                placeholder="选择日期时间" style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="家庭住址" prop="homeAddress" class="formItem">
                            <el-input type="textarea" v-model="addForm.homeAddress" clearable placeholder="请输入"
                                maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeData">取 消</el-button>
                    <el-button type="primary" @click="addEventForm()" v-if="eventControl !== '查看详情'">保 存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { partyMemberInfo } from '@/api/comprehensive'
import { listCompanyfInfo } from '@/api/searchList'
import { nationData, educationData } from './optionData'
import { validPhone, validateEmail } from '../../utils/validate'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
export default {
    name: 'partyMember',
    components: {
        TableList,
    },
    data() {
        return {
            nationData,
            educationData,
            loading: false,
            searchFrom: {
                chineseName: '', // 姓名
                sex: '', // 性别
                nationality: '', // 民族
                tel: '', // 电话
            },
            birthday: [], // 生日
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            dialogFormVisible: false,
            eventControl: '',
            edit: false,
            passwordForm: {},
            addForm: {
                chineseName: '', // 姓名
                sex: '', // 性别
                nationality: '', // 民族
                email: '', // 邮箱
                tel: '', // 电话
                birthday: '', // 生日
                joinDate: '', // 入党日期
                educational: '', // 学历
                homeAddress: '', // 学历
                companyId: '', // 学历
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e7;
                }
            },
            rules: {
                chineseName: [{ required: true, message: '请填写', trigger: 'blur' }],
                sex: [{ required: true, message: '请选择', trigger: 'blur' }],
                nationality: [{ required: true, message: '请选择', trigger: 'blur' }],
                email: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validateEmail, trigger: 'blur' }],
                tel: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validPhone, trigger: 'blur' }],
                birthday: [{ required: true, message: '请选择', trigger: 'blur' }],
                joinDate: [{ required: true, message: '请选择', trigger: 'blur' }],
                educational: [{ required: true, message: '请选择', trigger: 'blur' }],
            },
            tableData: [],
            companyValueList: [],
            sexOptions: [
                {
                    label: '男',
                    value: 1
                },
                {
                    label: '女',
                    value: 0
                },
            ],
            tableColumns: [
                {
                    prop: 'chineseName',
                    label: '姓名'
                },
                {
                    prop: 'sex',
                    label: '性别',
                    formatter: (row, column, v) => {
                        return (this.sexOptions.find(v => v.value === row.sex)).label
                    }
                },
                {
                    prop: 'companyName',
                    label: '所属公司'
                },
                {
                    prop: 'nationality',
                    label: '民族'
                },
                // {
                //   prop: 'status',
                //   label: '状态',
                //   formatter: (row, column, v) => {
                //     return (this.statusOptions.find(v => v.value === row.status)).label
                //   }
                // },
                {
                    prop: 'tel',
                    label: '联系电话'
                },
                {
                    prop: 'birthday',
                    label: '出生年月'
                },
                {
                    prop: 'educational',
                    label: '学历'
                },
                {
                    prop: 'joinDate',
                    label: '入党日期'
                },
                {
                    prop: 'action',
                    label: '操作',
                },
            ]
        }
    },
    mounted() {
        this.getData()
        this.getCompanyList()
    },
    methods: {
        // 公司下拉框
        async getCompanyList() {
        let res = await listCompanyfInfo({})
        if (res.code === 0) {
            this.companyValueList = res.result
        }
        },
        handleFile(imgs) {
            let arrFile = imgs.map(v => v.name).join(',')
            this.addForm.fileUrlList = arrFile
        },
        getData() {
            this.currentPage = 1
            this.queryList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.queryList()
        },
        async queryList() {
            let res = await partyMemberInfo('query', {
                // status: this.searchFrom.status,
                ...this.searchFrom,
                startTime: this.birthday?.[0] || '',
                endTime: this.birthday?.[1] || '',
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.tableData = res.result.records.map(v => {
                    return {
                        ...v.entity,
                        companyName: v.companyName,
                        companyId: v.entity.companyId === 0 ? '' : v.entity.companyId
                    }
                })
                this.totalCount = res.result.total
            }
        },
        addFormData() {
            this.edit = false
            this.dialogFormVisible = true
            this.eventControl = '添加成员'
        },
        async viewOrHandle(row, type) {
            console.log(row);
            this.edit = true
            this.eventControl = type === 'edit' ? '添加成员' : '查看详情'
            this.newOldFormContrast(row)
            this.dialogFormVisible = true
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
        },
        closeData() {
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.addForm = this.$options.data.call(this).addForm
        },
        addEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    if (this.edit) {
                        let res = await partyMemberInfo('update', this.addForm)
                        if (res.code === 0) {
                            Message.success('编辑成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.warning({ message: res.message })
                        }
                    } else {
                        let res = await partyMemberInfo('add', this.addForm)
                        if (res.code === 0) {
                            Message.success('新增成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.error(res.message)
                        }
                    }
                }
            })
        },
        // 删除用户
        deleteFun(row) {
            this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    'id': row.id
                }
                let res = await partyMemberInfo('delete', params)
                if (res.code === 0) {
                    Message.success('删除成功！')
                }
                await this.getData()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
}

.searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
        margin-top: 0.14rem;
        margin-left: .3rem;
        float: left;
    }

    .searchText {
        margin-top: 0.05rem;
        margin-right: 0.13rem;
        font-size: 0.2rem;
        color: #111111;
        float: left;
    }

    .inputDiv {
        width: 2.2rem;
        float: left;
    }

    .searchBtn {
        /*width: 1.20rem;*/
        /*height: 0.36rem;*/
        /*border-radius: 0.06rem;*/
        /*font-size: 0.18rem;*/
        margin-top: 0.14rem;
        margin-left: .3rem;
        /*padding-top: 0.1rem;*/
    }
}

.table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;

    .searchList {}

    .paginationBody {
        margin-top: .1rem;
    }
}

.formItem {
    // width: 3.2rem;
}

/deep/ .el-dialog {
    width: 30% !important;
}
</style>
